import PersonalityHobColumn from "../../components/profilecard/personalityhobcolumn";

import images from "../../assets";
import "./styles.css";

export default function PersonalityHobbiCard(props) {
  return (
    <div className="personality-hobbies hobbies-info-card">
      <div className="basic-info-head">
        <div className="h-[25px] w-[35px] border-[2px]  border-basePrimary rounded-md bg-[#eae6ed] flex justify-center items-center">
          <img
            src={images.personalityHobbiesIcon}
            alt="personalityhobby"
            className="h-[12px]"
          />{" "}
        </div>
        <span>Personality & Hobbies</span>
      </div>
      <div className="hobbies-info-content">
        {props?.othersProfileData?.foodPreference?.length > 0 && (
          <>
            <div className="hobbies-info-title">Favorite Food</div>
            <PersonalityHobColumn>
              {props?.othersProfileData?.foodPreference?.map((item, index) => {
                if (index === 0) {
                  return <p key={index}>{item}</p>;
                } else {
                  return <p key={index}>{item}</p>;
                }
              })}
            </PersonalityHobColumn>
          </>
        )}
        {props?.othersProfileData?.musicPreference?.length > 0 && (
          <>
            <div style={{ paddingTop: "10px" }} className="hobbies-info-title">
              Favorite Music
            </div>

            <PersonalityHobColumn>
              {props?.othersProfileData?.musicPreference?.map(
                (item, index, key) => {
                  if (index === 0) {
                    return <p key={index}>{item}</p>;
                  } else {
                    return <p key={index}>{item}</p>;
                  }
                }
              )}
            </PersonalityHobColumn>
          </>
        )}
        {props?.othersProfileData?.personalityTraits?.length > 0 && (
          <>
            <div style={{ paddingTop: "10px" }} className="hobbies-info-title">
              Personality Traits
            </div>

            <PersonalityHobColumn>
              {props?.othersProfileData?.personalityTraits?.map(
                (item, index, key) => {
                  if (index === 0) {
                    return <p key={index}>{item}</p>;
                  } else {
                    return <p key={index}>{item}</p>;
                  }
                }
              )}
            </PersonalityHobColumn>
          </>
        )}
        {props?.othersProfileData?.visitedCountries?.length > 0 && (
          <>
            <div style={{ paddingTop: "10px" }} className="hobbies-info-title">
              Countries Traveled
            </div>

            <PersonalityHobColumn>
              {props?.othersProfileData?.visitedCountries?.map(
                (item, index, key) => {
                  if (index === 0) {
                    return <p key={index}>{item}</p>;
                  } else {
                    return <p key={index}>{item}</p>;
                  }
                }
              )}
            </PersonalityHobColumn>
          </>
        )}
        {props?.othersProfileData?.weekendPreference?.length > 0 && (
          <>
            <div style={{ paddingTop: "10px" }} className="hobbies-info-title">
              Preferred Weekend Pastime
            </div>

            <PersonalityHobColumn>
              {props?.othersProfileData?.weekendPreference?.map(
                (item, index, key) => {
                  if (index === 0) {
                    return <p key={index}>{item}</p>;
                  } else {
                    return <p key={index}>{item}</p>;
                  }
                }
              )}
            </PersonalityHobColumn>
          </>
        )}
        {props?.othersProfileData?.bookPreference?.length > 0 && (
          <>
            <div style={{ paddingTop: "10px" }} className="hobbies-info-title">
              Preferred Type of Books
            </div>

            <PersonalityHobColumn>
              {props?.othersProfileData?.bookPreference?.map(
                (item, index, key) => {
                  if (index === 0) {
                    return <p key={index}>{item}</p>;
                  } else {
                    return <p key={index}>{item}</p>;
                  }
                }
              )}
            </PersonalityHobColumn>
          </>
        )}
        {props?.othersProfileData?.hobbies?.length > 0 && (
          <>
            <div style={{ paddingTop: "10px" }} className="hobbies-info-title">
              Hobbies
            </div>

            <PersonalityHobColumn>
              {props?.othersProfileData?.hobbies?.map((item, index, key) => {
                if (index === 0) {
                  return <p key={index}>{item}</p>;
                } else {
                  return <p key={index}>{item}</p>;
                }
              })}
            </PersonalityHobColumn>
          </>
        )}
      </div>
    </div>
  );
}
